export default __webpack_public_path__ + "reading-page-flip.mp3";